export default "/assets/images/smoky-gray-sm.webp?14b64ea198a25cc39910a267229149a5";